import type React from 'react';

import { CommonSvg } from '../CommonSVG';
import { ICON_DEFAULT_SIZE } from '../iconDefaultSize';
import type { Props } from '../type';

interface SolidIconProps extends Props {
  children: React.ReactNode;
}

export const SVGSolidIcon = ({
  size = ICON_DEFAULT_SIZE,
  width = size,
  height = size,
  viewBox = `0 0 ${ICON_DEFAULT_SIZE} ${ICON_DEFAULT_SIZE}`,
  children,
  alt,
  color,
  ...rest
}: SolidIconProps) => (
  <CommonSvg
    fill={color}
    height={height}
    width={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {alt && <title>{alt}</title>}
    {children}
  </CommonSvg>
);
